import { defineMessages } from 'react-intl';

const messages = defineMessages({
  taxTIN: {
    defaultMessage: 'TIN',
    id: '257pqZ',
    description: 'Tax ID Type TIN',
  },
  taxEIN: {
    defaultMessage: 'EIN',
    id: 'q2acN0',
    description: 'Tax ID Type EIN',
  },
  taxSSN: {
    defaultMessage: 'SSN',
    id: 'WFyHix',
    description: 'Tax ID Type SSN',
  },
  taxVAT: {
    defaultMessage: 'VAT',
    id: 'UOPvKR',
    description: 'Tax ID Type VAT',
  },
  taxEORI: {
    defaultMessage: 'EORI',
    id: 'JOdYqo',
    description: 'Tax ID Type EORI',
  },
  taxIOSS: {
    defaultMessage: 'IOSS',
    id: '8mHnJZ',
    description: 'Tax ID Type IOSS',
  },
  taxPAN: {
    defaultMessage: 'PAN',
    id: 'y6jbKz',
    description: 'Tax ID Type PAN',
  },
  taxVOEC: {
    defaultMessage: 'VOEC',
    id: 'pnM0Wd',
    description: 'Tax ID Type VOEC',
  },
  taxUKIMS: {
    defaultMessage: 'UKIMS',
    id: 'pJJe4E',
    description: 'Tax ID Type UKIMS',
  },
});

export const TaxIdentifierTypes = {
  taxTIN: {
    value: 'TIN',
  },
  taxEIN: {
    value: 'EIN',
  },
  taxSSN: {
    value: 'SSN',
  },
  taxVAT: {
    value: 'VAT',
  },
  taxEORI: {
    value: 'EORI',
  },
  taxIOSS: {
    value: 'IOSS',
  },
  taxPAN: {
    value: 'PAN',
  },
  taxVOEC: {
    value: 'VOEC',
  },
  taxUKIMS: {
    value: 'UKIMS',
  },
};

Object.keys(TaxIdentifierTypes).forEach((taxIdentifier) => {
  if (messages[taxIdentifier]) {
    TaxIdentifierTypes[taxIdentifier].messageDescriptor = messages[taxIdentifier];
  }
});

export const TaxIdTypeMessages = Object.values(TaxIdentifierTypes).reduce((map, type) => {
  return {
    ...map,
    [type.value]: type.messageDescriptor,
  };
}, {});
